/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */

import {
    commonUTCForSale,
    saleClosing,
    saleDetails,
    saleImageList,
    salesList,
    advlist,
    sneakpeekList
} from '../settings/apiconfig';
import interfaceService from './interfaceService';
import { getAppHeaders, getBuyerHeaders, getBuyersUrl, getSellerUrl } from 'shared/http';


class SalesService {
    constructor() {
        this.service = interfaceService.getService();
    }

    getSalesList(data) {
        return this.service.post(getSellerUrl(salesList), JSON.stringify(data), getAppHeaders());
    }

    getSaleImagesList(data) {
        return this.service.post(getSellerUrl(saleImageList), JSON.stringify(data), getAppHeaders());
    }
    getAdvList(data) {
        return this.service.post(getBuyersUrl(advlist), JSON.stringify(data), getBuyerHeaders());
    }

    getSaleDetails(saleId, data = {}) {
        return this.service.post(getSellerUrl(`${saleDetails}${saleId}`), JSON.stringify(data), getAppHeaders());
    }

    getSaleClosingTime(saleId) {
        return this.service.get(getBuyersUrl(`${saleClosing}${saleId}`), getBuyerHeaders(false));
    }

    UTCForSale() {
        return this.service.get(getBuyersUrl(`${commonUTCForSale}`), getBuyerHeaders(false));
    }

    getSneakPeekSaleList(data) {
        return this.service.post(getBuyersUrl(sneakpeekList), JSON.stringify(data), getBuyerHeaders());
    }
}

export default new SalesService();